import { render, staticRenderFns } from "./LabToolKuberEz.vue?vue&type=template&id=de5b13c8&scoped=true&xmlns%3Av-on=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./LabToolKuberEz.vue?vue&type=script&lang=js&"
export * from "./LabToolKuberEz.vue?vue&type=script&lang=js&"
import style0 from "./LabToolKuberEz.vue?vue&type=style&index=0&id=de5b13c8&scoped=true&lang=css&rel=stylesheet%2Fcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5b13c8",
  null
  
)

export default component.exports